import React, { useMemo, useState } from 'react';
// import Quote from './Quote';

const filters = [
  { label: 'View All', value: 'all' },
  { label: 'Solicitors', value: 'solicitor' },
  { label: 'Manager', value: 'manager' },
  // { label: 'Paralegals', value: 'paralegals' },
];

const people = [
  {
    name: 'Mohammed Khaled Hussain',
    role: 'Principal Solicitor',
    category: 'solicitor',
    initials: 'MK',
    summary:
      'Amina leads the firm with a focus on practical legal strategy, client care, and commercially aware dispute resolution.',
    email: 'amina@blackhorselaw.com',
  },
  {
    name: 'Tanvir Ahmed',
    role: 'Practice Manager',
    category: 'manager',
    initials: 'TA',
    summary:
      'Nadia supports clients through complex immigration applications, appeals, and compliance questions with calm, detailed advice.',
    email: 'nadia@blackhorselaw.com',
  },
  // {
  //   name: 'Sara Ahmed',
  //   role: 'Senior Paralegal',
  //   category: 'paralegals',
  //   initials: 'SA',
  //   summary:
  //     'Sara assists with case preparation, client communication, and document management across the firm\'s core practice areas.',
  //   email: 'sara@blackhorselaw.com',
  // },
];

const portraitStyles = [
  'bg-purple text-white',
  'bg-green text-white',
  'bg-blue text-white',
  'bg-[#C9A04A] text-text-color',
];

const OurPeople = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const visiblePeople = useMemo(() => {
    if (activeFilter === 'all') {
      return people;
    }

    return people.filter((person) => person.category === activeFilter);
  }, [activeFilter]);

  return (
    <>
      <section className="homepageBanner pt-36 pb-16 lg:pt-52 lg:pb-24">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl">
            <p className="mb-5 text-sm font-semibold uppercase tracking-wider text-white/80">
              Blackhorse Law
            </p>
            <h1 className="mb-6 text-4xl font-bold text-white lg:text-6xl">
              Our People
            </h1>
            <p className="text-base leading-7 text-white/90 lg:text-lg">
              We have a dedicated team of solicitors, trainees, paralegals, and management staff working together to support our clients with clear, practical legal advice.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white py-8">
        <div className="container mx-auto px-4">
          <div className="mb-12 grid gap-8 lg:grid-cols-[0.75fr_1.25fr] lg:items-end">
            <div>
              <h2 className="mb-4 text-3xl font-bold text-text-color lg:text-4xl">
                Meet the team
              </h2>
              <p className="max-w-md text-gray-600">
                Browse our people by role and find the right member of the firm to help with your matter.
              </p>
            </div>

            <div className="flex flex-wrap gap-3 lg:justify-end">
              {filters.map((filter) => (
                <button
                  key={filter.value}
                  type="button"
                  onClick={() => setActiveFilter(filter.value)}
                  className={`border px-4 py-2 text-sm font-semibold transition ${activeFilter === filter.value
                    ? 'border-purple bg-purple text-white'
                    : 'border-gray-300 bg-white text-text-color hover:border-purple hover:text-purple'
                    }`}
                >
                  {filter.label}
                </button>
              ))}
            </div>
          </div>

          <div className="grid gap-x-8 gap-y-12 md:grid-cols-2 lg:grid-cols-2">
            {visiblePeople.map((person, index) => (
              <article key={person.name} className="group">
                <div
                  className={`mb-6 flex aspect-[4/5] items-center justify-center text-5xl font-bold transition group-hover:opacity-90 ${portraitStyles[index % portraitStyles.length]
                    }`}
                  aria-label={`${person.name} portrait placeholder`}
                >
                  {person.initials}
                </div>
                <h3 className="mb-2 text-2xl font-bold text-text-color">{person.name}</h3>
                <p className="mb-4 font-semibold text-purple">{person.role}</p>
                {/* <p className="mb-5 text-sm leading-6 text-gray-600">{person.summary}</p> */}
                <a
                  href={`mailto:${person.email}`}
                  className="inline-flex items-center gap-2 font-semibold text-green hover:text-purple"
                >
                  <span>Full profile</span>
                  <span aria-hidden="true">-&gt;</span>
                </a>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* <Quote /> */}
    </>
  );
};

export default OurPeople;
